import {
  ExpertSystemHierarchyNode,
  InstallationStatus,
  Iso8601,
  KpiCalculationError,
  MillType,
  User
} from '@hconnect/common/types'

export type HierarchyTableNode = Omit<ExpertSystemHierarchyNode, 'children'> &
  MonthColumns & {
    subItems?: HierarchyTableNode[]
    average?: number
    averageError?: KpiCalculationError
    averageIsDirty?: boolean
  }

export enum ExpertSystemUsageRateColumnKeys {
  // this keeps the order of the columns as is
  // ex: Location is first column, Responsible is second column, etc.
  LOCATION = 'location',
  MILL_TYPE = 'millType',
  EXPERT_SYSTEM_NAME = 'expertSystemName',
  JAN = 'jan',
  FEB = 'feb',
  MAR = 'mar',
  APR = 'apr',
  MAY = 'may',
  JUN = 'jun',
  JUL = 'jul',
  AUG = 'aug',
  SEP = 'sep',
  OCT = 'oct',
  NOV = 'nov',
  DEC = 'dec',
  AVERAGE = 'value'
}

export type MonthColumns = {
  jan?: MonthData
  feb?: MonthData
  mar?: MonthData
  apr?: MonthData
  may?: MonthData
  jun?: MonthData
  jul?: MonthData
  aug?: MonthData
  sep?: MonthData
  oct?: MonthData
  nov?: MonthData
  dec?: MonthData
}

export type MonthDataColumns = {
  [key: string]: MonthColumns
}

export type MonthData = {
  value?: number
  isEditedManually: boolean
  isDirty: boolean
  kpiCalculationError?: KpiCalculationError
  hasComments?: boolean
}

export type YearlyKpiValue = {
  hierarchyId: string
  year: number
  isEditedManually: boolean
  isDirty: boolean
  kpiCalculationError?: KpiCalculationError
  value?: number
}

export type MtmKpiValue = {
  hierarchyId: string
  isEditedManually: boolean
  kpiCalculationError?: KpiCalculationError
  month: string
  isDirty: boolean
  value?: number
  hasComments?: boolean
}

export enum ExpertSystemEquipmentType {
  Mill = 'mill',
  Kiln = 'kiln'
}

export type YearMonth = string // YYYY-MM

export type HistoricalKpiValue = {
  value?: number
  kpiCalculationError?: KpiCalculationError
  version: number
  modifiedBy?: User
  modifiedAt: Iso8601
}

export type HistoricalDialogData =
  | {hierarchyId: string; equipmentName: string; month: string}
  | undefined

export type Item = {
  id?: string
  name: string
  millType?: MillType
  expertSystemName?: string
  kpiAssignmentId: string
  label?: string
  upmDepartmentId?: string
  provider?: string
  installationStatus?: InstallationStatus
  installationStatusText?: string
  installationYear?: string
}

export type AssignedUser = {
  userId: string
  id: string
  name: string
}
export type CommentKpiValue = {
  id: string
  content: string
  author: {
    id: string
    name: string
  }
  createdAt: Iso8601
  modifiedAt: Iso8601
  isDeleted: boolean
}

export type NewCommentKpi = {
  content: string
  replyToCommentId?: string
}
